import { FC, useEffect } from 'react'
import { Select } from 'antd'
import { useFranchises } from '@/hooks/useFranchises'

interface FranchiseSelectProps {
  value?: number[]
  onChange: (value: number[]) => void
  required?: boolean
  disabled?: boolean
  label?: string
  className?: string
  multiple?: boolean
}

const FranchiseSelect: FC<FranchiseSelectProps> = ({
  value = [],
  onChange,
  required = false,
  disabled = false,
  label = 'Выберите филиалы',
  className,
  multiple = true,
}) => {
  const { enabled, options, autoSelect, loading } = useFranchises()

  useEffect(() => {
    if (enabled && autoSelect && options.length === 1 && !value.length) {
      onChange([Number(options[0].value)])
    }
  }, [enabled, autoSelect, options, value.length, onChange])

  if (!enabled) {
    return null
  }

  return (
    <label className={className} style={{ display: 'grid', gap: 7 }}>
      <span style={{ fontWeight: 600 }}>
        {label}
        {required ? ' *' : ''}
      </span>
      <Select
        mode={multiple ? 'multiple' : undefined}
        allowClear
        showSearch
        optionFilterProp="label"
        loading={loading}
        disabled={disabled}
        value={multiple ? value : value[0]}
        options={options}
        onChange={(items) =>
          onChange(
            Array.isArray(items)
              ? items.map(Number)
              : items === undefined || items === null
                ? []
                : [Number(items)],
          )
        }
        placeholder={multiple ? 'Выберите филиалы' : 'Выберите филиал'}
        notFoundContent="Филиалы не найдены"
      />
    </label>
  )
}

export default FranchiseSelect
